// Distribución por dimensión D1..D6 · vista Oficial.
import React from 'react';

const DIMENSIONES_LABEL = {
  D1: 'Salud emocional',
  D2: 'Convivencia',
  D3: 'Vulneración',
  D4: 'Crisis',
  D5: 'Conductas de riesgo',
  D6: 'Contexto socioemocional',
};

export default function DimensionDistribution({ dimensiones = [], loading }) {
  const maxN = Math.max(1, ...dimensiones.map((d) => d.n_casos || 0));
  return (
    <section
      aria-label="Distribución por dimensión"
      className="bg-white rounded-2xl border border-[#E5EAF5] p-5"
      data-testid="dimension-distribution"
    >
      <header className="mb-4 flex items-center justify-between">
        <div>
          <h2 className="font-extrabold text-[#0B1B5E]">Distribución por dimensión</h2>
          <p className="text-xs text-[#475472]">Casos activos por dominio (últimos 30 días)</p>
        </div>
      </header>

      {loading ? (
        <div className="text-sm text-[#475472]">Cargando…</div>
      ) : (
        <div className="space-y-3">
          {dimensiones.map((d) => {
            const pct = Math.round(((d.n_casos || 0) / maxN) * 100);
            return (
              <div key={d.dominio_code} className="flex items-center gap-3" data-testid={`dim-${d.dominio_code}`}>
                <div className="w-14 shrink-0">
                  <div className="text-xs font-extrabold text-[#0B1B5E]">{d.dominio_code}</div>
                  <div className="text-[10px] text-[#475472] leading-tight">{DIMENSIONES_LABEL[d.dominio_code] || d.dominio_nombre}</div>
                </div>
                <div className="flex-1 h-6 bg-[#F4F7FE] rounded-lg overflow-hidden flex">
                  {[
                    { n: d.n_verdes, color: '#1E9F73' },
                    { n: d.n_amarillos, color: '#E0A81E' },
                    { n: d.n_naranjos, color: '#D97706' },
                    { n: d.n_rojos, color: '#B91C1C' },
                  ].map((s, i) => {
                    if (!s.n) return null;
                    const w = ((s.n / (d.n_casos || 1)) * 100).toFixed(1);
                    return <div key={i} style={{ width: `${w}%`, background: s.color }} title={`${s.n}`} />;
                  })}
                  {(d.n_casos || 0) === 0 && (
                    <div className="w-full flex items-center px-2 text-[10px] text-[#94A3B8]">Sin casos activos</div>
                  )}
                </div>
                <div className="w-12 text-right text-sm font-bold text-[#0B1B5E]">{d.n_casos || 0}</div>
              </div>
            );
          })}
        </div>
      )}

      <div className="mt-4 flex flex-wrap gap-3 text-[10px] text-[#475472]">
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-[#1E9F73]"/>Verde</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-[#E0A81E]"/>Amarillo</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-[#D97706]"/>Naranjo</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-[#B91C1C]"/>Rojo</span>
      </div>
    </section>
  );
}
